var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-max" }, [
    _c(
      "div",
      { staticClass: "owl-carousel owl-theme brand-abc-letters-bar" },
      _vm._l("ABCDEFGHIJKLMNOPQRSTUVWXYZ".split(""), function (letter) {
        return _c(
          "a",
          {
            key: letter,
            staticClass: "item",
            class: { "not-available": !_vm.letters.includes(letter) },
            attrs: { href: "#" + letter },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.scrollTo(letter)
              },
            },
          },
          [_vm._v("\n      " + _vm._s(letter) + "\n    ")]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "brand-abc pb-5" },
      _vm._l(_vm.sortedBrandArray, function (letter) {
        return _c(
          "div",
          {
            key: letter[0],
            staticClass: "brand-abc-inner",
            attrs: { id: letter[0] },
          },
          [
            _c("div", { staticClass: "d-block h1" }, [
              _vm._v(_vm._s(letter[0])),
            ]),
            _vm._v(" "),
            _vm._l(letter[1], function (brand) {
              return _c("div", { key: brand.id }, [
                _c(
                  "a",
                  {
                    staticClass: "text-light",
                    attrs: { href: brand.lang.de.url },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          brand.lang.de.name.split(" ").slice(1).join(" ")
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ])
            }),
          ],
          2
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }